module.exports = __webpack_public_path__ + "img/u.b1df33e1.svg";